export const featureFlags = {
  inventoryV3: 'inventory_v3_features',
  vulnerabilityV3: 'new_vuln_dashboard',
  alertVault: 'alert_vault_feature',
  // Gate the MFA settings rollout independently of server-side policy enforcement.
  mfa: 'mfa_feature',
} as const;

export const isFeatureEnabled = (flag?: { enabled?: boolean }) =>
  flag?.enabled === true;
